import axios from "axios";
import LFEStore from "./SessionProvider"
import { Logout } from "./Reducers/SessionSlice";
axios.defaults.withCredentials = true

var BEARER_TOKEN = null

function getToken() {
  return BEARER_TOKEN
}

function setAPIToken(token) {
  console.log("Bearer token set", token)
  BEARER_TOKEN = token
}

let baseURL = import.meta.env.VITE_API_URL;
if (!baseURL) {
  console.warn('VITE_API_URL is not defined in environment variables. Fallback to default.');
  baseURL = 'http://localhost:35151/'; // Fallback
}

// Ensure trailing slash for consistency (optional, depending on usage)
if (!baseURL.endsWith('/')) {
  baseURL += '/';
}

// Helper function to get base URL without trailing slash (for WebSocket URLs)
function getBaseURL() {
  return baseURL.replace(/\/$/, '');
}

// Helper function to get WebSocket URL from HTTP endpoint
function getWebSocketUrl(endpoint) {
  const base = getBaseURL();
  // Convert http/https to ws/wss
  const wsProtocol = base.startsWith('https') ? 'wss' : 'ws';
  const wsBase = base.replace(/^https?:\/\//, '');

  return `${wsProtocol}://${wsBase}${endpoint}`;
}

const LysepAPI = axios.create({
  baseURL: baseURL,
  timeout: 60000,
  withCredentials: true
});
LysepAPI.interceptors.request.use(
  config => {
    config.headers["Authorization"] = "Bearer " + getToken();
    return config;
  },
  error => {
    Promise.reject(error);
  }
);
LysepAPI.interceptors.response.use(resp => resp, async (err) => {
  if (err?.response?.status === 401 || err?.response?.status === 403) {
    LFEStore.dispatch(Logout());
  }
  return Promise.reject(err);
});
export {
  LysepAPI,
  setAPIToken,
  getToken,
  getBaseURL,
  getWebSocketUrl
};